//let baseURL = 'https://cremosso.ro';
let baseURL = '';
const primaryLinks = {
    regulament: `${baseURL}/regulament`,
    politica_de_confidentialitate: `${baseURL}/politica-de-confidentialitate`,
    termeni_si_conditii: `${baseURL}/termeni-si-conditii`,
    politica_cookies: `${baseURL}/politica-cookies`
}
export default primaryLinks;
